import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class ListaNegraService {
  dataUrl = Config.URL_LISTA_NEGRA_SAT;
  constructor(private http: HttpClient) {
  }


  consultarEstatusRfc(rfc: string): Observable<any> {
    let url_ = this.dataUrl + '/sat/get/lista_campos/' + rfc;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


}
